import VouchersContent from "./VouchersContent";

export default VouchersContent;
